export default {
  add: 'Додати контакти',
  edit: 'Профіль контакту',
  save_success: 'Успішно збережено',
  modal: {
    about: 'Профіль',
    add: 'Додати до контактів',
    edit: 'Профіль контакту',
    description: 'If several languages coalesce, the grammar of the resulting language is more simple and regular than that of the individual.',
  },
  form: {
    phone: 'Номер телефону',
    name: 'Ім\'я Прізвище',
    first_name: 'Ім\'я',
    second_name: 'По батькові',
    last_name: 'Прізвище',
    birth_day: 'Дата народження',
    code: 'Код',
    email: 'EMail',
    date: 'Дата',
    sum: 'Кількість',
    param_1: 'Параметр 1',
    param_2: 'Параметр 2',
    param_3: 'Параметр 3',

    name_tag: '[[NAME]]',
    first_name_tag: '[[FIRST_NAME]]',
    second_name_tag: '[[SECOND_NAME]]',
    last_name_tag: '[[LAST_NAME]]',
    birth_day_tag: '[[BIRTH_DAY]]',
    code_tag: '[[CODE]]',
    email_tag: '[[EMAIL]]',
    date_tag: '[[DATE]]',
    sum_tag: '[[SUM]]',
    param_1_tag: '[[PARAM_1]]',
    param_2_tag: '[[PARAM_2]]',
    param_3_tag: '[[PARAM_3]]',
  },
};
